import { atomWithStorage } from "jotai/utils";

// Persist map "sub-step" across refresh so Locations screen doesn't unexpectedly
// switch from map modal -> non-map view on reload.
export const isMapShownAtom = atomWithStorage(
  "isMapShown", // localStorage key
  false // default value
);

export const isMinimizedAtom = atomWithStorage(
  "isMinimized", // localStorage key
  false // default value
);
